import React from 'react';
import { Card, Row, Col, Badge, Alert } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';

const AgentInfoCard = ({ agent, parentAgent }) => {
  if (!agent) return null;

  return (
    <Card className="agent-info-card">
      <Card.Header>
        <h2 className="section-heading">Agent Information</h2>
      </Card.Header>
      <Card.Body>
        <Row className="mb-3">
          <Col md={2}>
            <div className="info-item">
              <div className="info-label">Agent Number:</div>
              <div className="info-value">{agent.agentNumber}</div>
            </div>
          </Col>
          
          <Col md={4}>
            <div className="info-item">
              <div className="info-label">Name:</div>
              <div className="info-value">{agent.name}</div>
            </div>
          </Col>
          
          <Col md={3}>
            <div className="info-item">
              <div className="info-label">DEV Status:</div>
              <div className="info-value">
                <Badge bg={agent.deployedInDev ? 'success' : 'secondary'}>
                  {agent.deployedInDev ? 'Deployed' : 'Not Deployed'}
                </Badge>
              </div>
            </div>
          </Col>
          
          <Col md={3}>
            <div className="info-item">
              <div className="info-label">PROD Status:</div>
              <div className="info-value">
                <Badge bg={agent.deployedInProd ? 'success' : 'secondary'}>
                  {agent.deployedInProd ? 'Deployed' : 'Not Deployed'}
                </Badge>
              </div>
            </div>
          </Col>
        </Row>
        
        <Row>
          <Col md={12}>
            <div className="info-item">
              <div className="info-label">Description:</div>
              <div className="info-value">{agent.description}</div>
            </div>
          </Col>
        </Row>
        
        {!parentAgent && (
          <Alert variant="warning" className="mt-3">
            <FaInfoCircle className="me-2" />
            <strong>Warning:</strong> Parent agent information could not be loaded. Some functionality may be limited.
          </Alert>
        )}
      </Card.Body>
    </Card>
  );
};

export default AgentInfoCard;
